import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";

// --- Formateo RUT: xx.xxx.xxx-x ---
const formatRutPretty = (input = "") => {
  let v = input.toUpperCase().replace(/[^0-9K]/g, "");
  if (v.length < 2) return input;
  const dv = v.slice(-1);
  const cuerpo = v.slice(0, -1);
  let out = "";
  let c = 0;
  for (let i = cuerpo.length - 1; i >= 0; i--) {
    out = cuerpo[i] + out;
    c++;
    if (c % 3 === 0 && i !== 0) out = "." + out;
  }
  return `${out}-${dv}`;
};

const useDebounced = (value, ms = 350) => {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
};

const AlmuerzosDelDia = () => {
  const [rutInput, setRutInput] = useState("");
  const [fecha, setFecha] = useState(() => new Date().toISOString().slice(0, 10)); // hoy
  const [items, setItems] = useState([]);         // [{rut, fecha, almuerzo, nombre?, area?, centro_costo?}]
  const [mensaje, setMensaje] = useState("");
  const [cargando, setCargando] = useState(false);

  // Debounce del RUT para no disparar demasiadas consultas al tipear
  const rutDebounced = useDebounced(rutInput, 350);

  const fetchData = async (f, rutOpt) => {
    setCargando(true);
    setMensaje("");
    try {
      const resp = await axios.get(
        // nuevo endpoint (ver abajo) que lista por fecha y opcionalmente por RUT
        "https://casinop2.sanjoseapps.cl/api/get_programacion_dia.php",
        { params: { fecha: f, rut: rutOpt || "" } }
      );
      if (resp.data?.ok) {
        const arr = Array.isArray(resp.data.data) ? resp.data.data : [];
        setItems(arr);
        if (!arr.length) setMensaje("No hay almuerzos programados para ese día con el filtro actual.");
      } else {
        setItems([]);
        setMensaje(resp.data?.error || "No se pudo consultar.");
      }
    } catch (e) {
      setItems([]);
      setMensaje(e?.response?.data?.error || e.message || "Error de red.");
    } finally {
      setCargando(false);
    }
  };

  // 1) Carga automática cuando cambia la FECHA
  useEffect(() => {
    fetchData(fecha, rutDebounced.trim());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fecha]);

  // 2) Botón para consultar cuando cambie el RUT (opcional: también podrías auto-consultar al cambiar rutDebounced)
  const consultar = () => fetchData(fecha, rutDebounced.trim());

  // Ayuda visual
  const totalRegistros = useMemo(() => items.length, [items]);

  return (
    <>
      <Navbar />
      <section className="section">
        <div className="container">
          <h1 className="title">Almuerzos del día</h1>

          <div className="box">
            <div className="columns">
              <div className="column is-5">
                <div className="field">
                  <label className="label">RUT (opcional)</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      placeholder="12.345.678-9"
                      value={rutInput}
                      onChange={(e) => setRutInput(formatRutPretty(e.target.value))}
                      autoComplete="off"
                    />
                  </div>
                  <p className="help">Si lo dejas vacío, verás todos los almuerzos del día.</p>
                </div>
              </div>
              <div className="column is-4">
                <div className="field">
                  <label className="label">Fecha</label>
                  <div className="control">
                    <input
                      className="input"
                      type="date"
                      value={fecha}
                      onChange={(e) => setFecha(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="column is-3" style={{ display: "flex", alignItems: "flex-end" }}>
                <button
                  className={`button is-primary is-fullwidth ${cargando ? "is-loading" : ""}`}
                  type="button"
                  onClick={consultar}
                >
                  Buscar
                </button>
              </div>
            </div>

            {mensaje && <div className="notification is-info">{mensaje}</div>}

            <div className="is-flex is-justify-content-space-between is-align-items-center mb-2">
              <strong>Fecha: {fecha}</strong>
              <span>Total: {totalRegistros}</span>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table className="table is-striped is-hoverable is-fullwidth">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>RUT</th>
                    <th>Nombre</th>
                    <th>Área</th>
                    <th>Centro de Costo</th>
                    <th>Almuerzo</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((r, i) => (
                    <tr key={`${r.rut}-${r.fecha}-${i}`}>
                      <td>{i + 1}</td>
                      <td>{r.rut}</td>
                      <td>{r.nombre || r.Nombre || "-"}</td>
                      <td>{r.area || r.AreaTrabajo || "-"}</td>
                      <td>{r.centro_costo || r.CentroCosto || "-"}</td>
                      <td>{r.almuerzo}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default AlmuerzosDelDia;
